import { render, staticRenderFns } from "./ResetPassword.vue?vue&type=template&id=c2ef4206&scoped=true"
import script from "./ResetPassword.vue?vue&type=script&lang=js"
export * from "./ResetPassword.vue?vue&type=script&lang=js"
import style0 from "./ResetPassword.vue?vue&type=style&index=0&id=c2ef4206&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c2ef4206",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/kemingchen/Projects/VisionFutureWeb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c2ef4206')) {
      api.createRecord('c2ef4206', component.options)
    } else {
      api.reload('c2ef4206', component.options)
    }
    module.hot.accept("./ResetPassword.vue?vue&type=template&id=c2ef4206&scoped=true", function () {
      api.rerender('c2ef4206', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Auth/ResetPassword.vue"
export default component.exports